<section class="accordion">
  @for (item of items; track item; let i = $index) {
    <div class="accordion__item" [class.disabled]="item.disabled"
      [class.active]="expanded.has(i)">
      <ng-container [ngTemplateOutlet]="(item?.customHeader?.templateRef || defaultHeader)"
        [ngTemplateOutletContext]="{$implicit: item, index: i, toggle: i | getToggleFunction: toggleState}">
      </ng-container>
      <div class="accordion__content" [id]="contentId(i)" [class.expanded]="expanded.has(i)"
        [@contentExpansion]="expanded.has(i) ? 'expanded':'collapsed'"
        (@contentExpansion.done)="emitContentExpanded($event, i)"
        >
        <ng-container *ngTemplateOutlet="item?.content?.templateRef"></ng-container>
      </div>
    </div>
  }
</section>

<ng-template #defaultHeader let-item let-index="index">
  <!-- The toggle button's hit area is stretched over the whole header (see CSS), so the row
       stays clickable while the button remains the single keyboard and screen-reader control. -->
  <header class="accordion__header">
    <ng-container *ngTemplateOutlet="item?.customTitle?.templateRef || defaultTitle"></ng-container>
    <button type="button" class="accordion__toggle-btn" [disabled]="item.disabled"
      [attr.aria-expanded]="expanded.has(index)" [attr.aria-controls]="contentId(index)"
      (click)="toggleState(index)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
      </svg>
      <span class="sr-only">Toggle Accordion</span>
    </button>
  </header>
  <ng-template #defaultTitle>
    <div class="accordion__title">{{item?.title}}</div>
  </ng-template>
</ng-template>
